export default (state, action) => {
  const signature = action.payload;
  return { ...state, signature };
};
